import { render, staticRenderFns } from "./CardFilter.vue?vue&type=template&id=18f2278c&scoped=true&"
import script from "./CardFilter.vue?vue&type=script&lang=js&"
export * from "./CardFilter.vue?vue&type=script&lang=js&"
import style0 from "./CardFilter.vue?vue&type=style&index=0&id=18f2278c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f2278c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\src\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18f2278c')) {
      api.createRecord('18f2278c', component.options)
    } else {
      api.reload('18f2278c', component.options)
    }
    module.hot.accept("./CardFilter.vue?vue&type=template&id=18f2278c&scoped=true&", function () {
      api.rerender('18f2278c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "BuildABox/components/CardFilter.vue"
export default component.exports